import React, { Component } from 'react';
import { toast } from "react-toastify";
import { Button, Form } from 'react-bootstrap';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';

import axios from '../../../axios';
import TestSMSModal from './testwhatsappsms';
import apiError from '../../../error';
import Loader from '../../loader/loader';
import Spinner from '../../spinner/spinner';

export default class AttackProfileWhatsApp extends Component{
    constructor(props){
        super(props);
        this.state = {
            apiEndPoint: '',
            accessToken: '',
            gateways: [],
            gatewayId: 0,
            loading: false,
            gatewayNameIds: {},
            disableState: false,
            phone: '',
            show: false,
            xApiKey: '',
            botId: '',
            sender: ''
        }
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.senderId !== this.props.senderId) {
            this.load();
        }
    }

    loadGatway = () => {
        axios.get('/api/whatsapp-gateway', {})
        .then(res => {
            this.setState({ gateways: res.data.gateway })
            let gatewayNameIds = {}
            for(var i=0; i<res.data.gateway.length; i++){
                gatewayNameIds[res.data.gateway[i].id] = res.data.gateway[i].name;
            }
            this.setState({ gatewayNameIds: gatewayNameIds })
        })
        .catch(error => apiError(error))
    }

    load = () => {
        if(this.props.senderId){
            axios.get('/api/senders/'+this.props.senderId, {})
            .then(res => {
                if(res.data.sender){
                    this.setState({ 

                        disableState: true,
                        gatewayId: res.data.sender.whatsAppGatewayId,
                        /* for yellow api */
                        sender: res.data.sender.from_address,
                        botId: res.data.sender.host,
                        xApiKey: res.data.sender.username,

                        /* for wati */
                        apiEndPoint: res.data.sender.host,
                        accessToken: res.data.sender.username,

                    }, () => {
                        this.loadGatway();
                    })
                }
            })
            .catch(error => apiError(error))
        } else {
            this.loadGatway();
        }
    }

    validateSenderWati = () => {
        if(!this.state.gatewayId || this.state.gatewayId.length === 0){
            toast.error("Please Select SMS Gatway");
            return false;
        }
        if(!this.state.accessToken || this.state.accessToken.length === 0){
            toast.error("Please Enter Access Token");
            return false;
        }
        if(!this.state.apiEndPoint || this.state.apiEndPoint.length === 0){
            toast.error("Please Enter Api End Point");
            return false;
        }
        
        return {
            accessToken: this.state.accessToken,
            gatewayId: this.state.gatewayId,
            apiEndPoint: this.state.apiEndPoint,
            campaignTemplateId: this.props.campaignTemplateId
        }
    }

    validateSenderYellowAi = () => {
        if(!this.state.gatewayId || this.state.gatewayId.length === 0){
            toast.error("Please Select SMS Gatway");
            return false;
        }
        if(!this.state.sender || this.state.sender.length === 0){
            toast.error("Please Enter Sender");
            return false;
        }
        if(!this.state.botId || this.state.botId.length === 0){
            toast.error("Please Enter Bot Id");
            return false;
        }
        if(!this.state.xApiKey || this.state.xApiKey.length === 0){
            toast.error("Please Enter X-API-KEY");
            return false;
        }
        
        return {
            botId: this.state.botId,
            sender: this.state.sender,
            xApiKey: this.state.xApiKey,
            gatewayId: this.state.gatewayId,
            campaignTemplateId: this.props.campaignTemplateId
        }
    }

    validateSenderQontak = () => {
        if(!this.state.gatewayId || this.state.gatewayId.length === 0){
            toast.error("Please Select SMS Gatway");
            return false;
        }
        if(!this.state.accessToken || this.state.accessToken.length === 0){
            toast.error("Please Enter Access Token");
            return false;
        }
        
        return {
            accessToken: this.state.accessToken,
            gatewayId: this.state.gatewayId,
            campaignTemplateId: this.props.campaignTemplateId
        }
    }

    validateSenderUYON = () => {
        if(!this.state.gatewayId || this.state.gatewayId.length === 0){
            toast.error("Please Select SMS Gatway");
            return false;
        }
        return {
            gatewayId: this.state.gatewayId,
            campaignTemplateId: this.props.campaignTemplateId
        }
    }

    validateSenderInterakt = () => {
        try{
            if(!this.state.gatewayId || this.state.gatewayId.length === 0){
                toast.error("Please Select SMS Gatway");
                return false;
            }
            if(!this.state.accessToken || this.state.accessToken.length === 0){
                toast.error("Please Enter Access Token");
                return false;
            }
            
            return {
                accessToken: this.state.accessToken,
                gatewayId: this.state.gatewayId,
                campaignTemplateId: this.props.campaignTemplateId
            }
        }catch(error){
            console.log("Error occured while validating Interakt sender: ", error);
            return {};
        }
    }

    handleCreateSender = () => {
        if(this.state.gatewayNameIds[this.state.gatewayId] === "Wati"){
            const data = this.validateSenderWati();
            if(data){
                this.setState({ loading: true })
                if(this.props.senderId){
                    axios.patch('/api/senders/whatsapp/Wati/'+this.props.senderId, data )
                    .then(res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
                }else {
                    axios.post('/api/senders/whatsapp/Wati', data )
                    .then(res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                        this.props.handleSenderId(res.data.sender.id);
                        toast.success('Attack Profile Created Successfully') 
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
                }
            }
        }
        if(this.state.gatewayNameIds[this.state.gatewayId] === "Yellow.ai"){
            const data = this.validateSenderYellowAi();
            if(data){
                this.setState({ loading: true })
                if(this.props.senderId){
                    axios.patch('/api/senders/whatsapp/yellowai/'+this.props.senderId, data )
                    .then(res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
                }else {
                    axios.post('/api/senders/whatsapp/yellowai', data )
                    .then(res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                        this.props.handleSenderId(res.data.sender.id);
                        toast.success('Attack Profile Created Successfully') 
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
                }
            }
        }
        if(this.state.gatewayNameIds[this.state.gatewayId] === "Qontak"){
            const data = this.validateSenderQontak();
            if(data){
                this.setState({ loading: true })
                if(this.props.senderId){
                    axios.patch('/api/senders/whatsapp/Qontak/'+this.props.senderId, data )
                    .then(res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
                }else {
                    axios.post('/api/senders/whatsapp/Qontak', data )
                    .then(res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                        this.props.handleSenderId(res.data.sender.id);
                        toast.success('Attack Profile Created Successfully') 
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
                }
            }
        }
        if(this.state.gatewayNameIds[this.state.gatewayId] === "UYON"){
            const data = this.validateSenderUYON();
            if(data){
                this.setState({ loading: true })
                if(this.props.senderId){
                    axios.patch('/api/senders/whatsapp/uyon/'+this.props.senderId, data )
                    .then(res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
                }else {
                    axios.post('/api/senders/whatsapp/uyon', data )
                    .then(res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                        this.props.handleSenderId(res.data.sender.id);
                        toast.success('Attack Profile Created Successfully') 
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
                }
            }
        }
        if(this.state.gatewayNameIds[this.state.gatewayId] === "Interakt"){
            const data = this.validateSenderInterakt();
            if(data){
                this.setState({ loading: true })
                if(this.props.senderId){
                    axios.patch('/api/senders/whatsapp/Interakt/'+this.props.senderId, data )
                    .then(res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
                }else {
                    axios.post('/api/senders/whatsapp/Interakt', data )
                    .then(res => {
                        this.setState({ loading: false })
                        this.props.handleTabChange('next');
                        this.props.handleSenderId(res.data.sender.id);
                        toast.success('Attack Profile Created Successfully') 
                    })
                    .catch(error => {
                        this.setState({ loading: false })
                        apiError(error)
                    })
                }
            }
        }
    }

    render(){
        return (
            <>
                <div className="email-template-wrap">
                    <div className='rightSectionHeader'>
                        <div className="row justify-content-between align-items-center">
                            <div className="col-md-6 tab-right-header">
                                <h6>Attack Profile</h6>
                                <p>Create Attack Profile</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label>WhatsApp Profile</label>
                            <Form.Control as="select" disabled={this.state.disableState} value={this.state.gatewayId} onChange={e => {this.props.handleWhatsappGateway(this.state.gatewayNameIds[e.target.value]); this.setState({gatewayId: e.target.value})}} className="mb-2">
                                <option value='0'>Select WhatsApp Gateway</option>
                                {this.state.gateways.map((gatway, index) => {
                                    return <option key={index} value={gatway.id}>{gatway.name}</option>
                                })}
                            </Form.Control>
                            {this.state.gatewayNameIds[this.state.gatewayId] === "Wati" || this.state.gatewayNameIds[this.state.gatewayId] === "Interakt"?
                                <div>
                                    <Form.Group>
                                        <Form.Label>Access Token</Form.Label>
                                        <Form.Control as="textarea" rows={4} placeholder="please enter access token" value={this.state.accessToken} onChange={e => this.setState({accessToken: e.target.value})} />
                                    </Form.Group>
                                    {this.state.gatewayNameIds[this.state.gatewayId] === "Wati" && 
                                        <Form.Group>
                                            <Form.Label>API Endpoint</Form.Label>
                                            <Form.Control type="text" placeholder="please enter api token" value={this.state.apiEndPoint} onChange={e => this.setState({apiEndPoint: e.target.value})}/>
                                        </Form.Group>
                                    }
                                </div>: null
                            }
                            {this.state.gatewayNameIds[this.state.gatewayId] === "Yellow.ai"?
                                <div>
                                    <Form.Group>
                                        <Form.Label>Sender</Form.Label>
                                        <Form.Control type="text" placeholder="please enter Sender" value={this.state.sender} onChange={e => this.setState({sender: e.target.value})} />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>BotId</Form.Label>
                                        <Form.Control type="text" placeholder="please enter BotId" value={this.state.botId} onChange={e => this.setState({botId: e.target.value})} />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>X-API-KEY</Form.Label>
                                        <Form.Control as="textarea" rows={2} value={this.state.xApiKey} onChange={e => this.setState({xApiKey: e.target.value})}/>
                                    </Form.Group>
                                </div>: null
                            }
                            {this.state.gatewayNameIds[this.state.gatewayId] === "Qontak"?
                                <div>
                                   <Form.Group>
                                        <Form.Label>Qontak API Key</Form.Label>
                                        <Form.Control type="text" placeholder="Please enter the qontak api key" value={this.state.accessToken} onChange={e => this.setState({accessToken: e.target.value})}/>
                                    </Form.Group>
                               </div>: null
                            }
                        </div>
                    </div>
                </div>
                <div className="mt-2">
                    <div className='footer-wrapper justify-content-end d-flex'>
                        <Button variant="secondary" className="mr-2" onClick={e => this.props.handleTabChange('prev')}><ArrowBackOutlinedIcon className="btn-icon"></ArrowBackOutlinedIcon> Previous</Button>
                        <Button variant="success" disabled={this.state.loading} type="button" onClick={this.handleCreateSender}><Spinner loading={this.state.loading}></Spinner><ArrowForwardOutlinedIcon className={this.state.loading?"btn-icon d-none": "btn-icon"}></ArrowForwardOutlinedIcon> Go To Next</Button>
                    </div>
                </div>
                <TestSMSModal
                    show={this.state.show}
                    phone={this.state.phone}
                    loading={this.state.loading}
                    sendTestSMS={this.sendTestSMS}
                    handlePhone={e => this.setState({ phone: e.target.value })}
                    handleSMSModal={e => this.setState({ show: !this.state.show })}
                ></TestSMSModal>
                {this.state.loading? <Loader></Loader>: null}
            </>
        )
    }
}
